import { render, staticRenderFns } from "./sendIbpHint.vue?vue&type=template&id=0a54a701"
import script from "./sendIbpHint.vue?vue&type=script&lang=js"
export * from "./sendIbpHint.vue?vue&type=script&lang=js"
import style0 from "./sendIbpHint.vue?vue&type=style&index=0&id=0a54a701&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports